import { PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import '../../styles/tokens.stylex';
import { borderRadius, color, spacing } from '../../styles/tokens.stylex';
export interface VideoPreviewCardProps {
  data: PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial;
  playButton: React.ReactNode;
  onClick: () => void;
}
export function VideoPreviewCard({
  data,
  playButton,
  onClick
}: VideoPreviewCardProps) {
  const animationSrc = function () {
    if (data?.video?.videoId) {
      const muxSrc = `https://image.mux.com/${data.video.videoId}/animated.webp`;
      const aminationConfig = {
        start: data.video?.animationStartTime,
        end: (data.video?.animationStartTime || 0) + (data?.video?.animationDuration || 0),
        fps: '15',
        width: 640
      };
      const validConfig = Object.entries(aminationConfig).reduce((acc, [key, val]) => val ? {
        ...acc,
        [key]: val
      } : acc, {});
      const params = new URLSearchParams(validConfig);
      return muxSrc + '?' + params.toString();
    }
    return null;
  }();
  return <div className="xgsuvyv x1o4oh2x xrvj5dj x619ttb xpqajaz xrhgmaw x1dltgaz xranhgd x1n2onr6 xb3r6kr x1ypdohk x12h1iku" data-tina-field={tinaField(data, 'video')} onClick={onClick}>
      {data.video?.image && <>
          <Image src={data.video.image} alt={data.video.alt as string} fill className="xl1xv1r" sizes="90vw, (min-width: 600px) 45vw" />
          {animationSrc && <Image src={animationSrc} alt="animated preview" fill className="xl1xv1r xg01cxk x1o7uuvo x1tt87w1 x1larqbn x1s85apg xe2mjoi" sizes="90vw, (min-width: 600px) 45vw" unoptimized />}
          {data.video.logoOverlay && <div className="x10l6tqk x191j7n5 xn5hqff xmrfuvb x186iv6y">
              <Image src={data.video.logoOverlay} alt="The company logo" fill sizes="120px" className="x19kjcj4" />
            </div>}
        </>}
      {playButton}
    </div>;
}